import React from "react";
import { Card } from "react-bootstrap";

const InwardLetter = ({ data, prefaceData }) => {
    const currentDate = new Date().toLocaleDateString("en-GB");
    const prefaceInfo = prefaceData?.data || {
        name: "-",
        address: "-",
        gstin: "-",
        icegate_id: "-"
    };

    const formatDMY = (d) => {
        if (!d) return "-";
        const [day, month, year] = d.split("/");
        return `${day}/${month}/${year}`;
    };

    const formatISODate = (d) => {
        return new Date(d).toLocaleDateString("en-GB", { timeZone: "UTC" });
    };
    
    return (
        <Card
            className="border-0"
            style={{
                fontSize: "16px",
                lineHeight: "1.6",
                backgroundColor: "#fff",
                fontFamily: '"Times New Roman", Times, serif',
                padding: "30px 0", // Only top and bottom padding, no left/right
            }}
        >
            {/* Title */}
            <h5
                className="text-center mb-3 custom-heading"
                style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    textDecoration: "underline",
                }}
            >
                TRANSFER LETTER AND UNDERTAKING FOR E-SCRIP
            </h5>

            {/* To Section - Your Company (Recipient) */}
            <div className="mb-3">
                <p className="mb-2">
                    <strong>To,</strong>
                </p>
                <p className="mb-1" style={{ fontWeight: "500" }}>
                    {prefaceInfo.name}
                </p>
                <p className="mb-2" style={{ whiteSpace: "pre-line" }}>
                    {prefaceInfo.address}
                </p>
                <p className="mb-1">
                    <strong>GSTN:</strong> {prefaceInfo.gstin}
                </p>
                <p className="mb-3">
                    <strong>ICEGATE ID:</strong> {prefaceInfo.icegate_id}
                </p>

                {/* Subject */}
                <p
                    className="mb-3"
                    style={{
                        textDecoration: "underline",
                        fontWeight: "500"
                    }}
                >
                    Subject: Sale and Transfer of RoSCTL/RoDTEP Duty Credit E-scrip in your favour as per Foreign Trade Policy in force and Notifications No. 75/2021 Customs (NT) dtd. 23.09.2021 and/or Notification No. 76/2021 Customs (NT) dtd. 23.09.2021 and/or Notification No. 77/2021 Customs (NT) dtd. 24.09.2021.
                </p>

                {/* E-scrip Details */}
                <p className="mb-1">
                    <strong>E-scrip No. : {data.escrip_no || "-"}</strong>  &nbsp;&nbsp;
                    <strong> Dated : {data.dated ? formatISODate(data.dated) : "-"}</strong> &nbsp;&nbsp;
                    <strong>Duty Credit Amt (Rs.):</strong> {data.amount || "-"}
                </p>
                <p className="mb-3">
                    <strong>Port Code : </strong> {data.port_code || "-"} &nbsp;&nbsp;
                    <strong>IEC :</strong> {data.iec || "-"}
                </p>
            </div>

            {/* Letter Body */}
            <div style={{ fontSize: "16px" }}>
                <p className="mb-3">Dear Sir/Madam,</p>

                <p className="mb-3" style={{ textAlign: "justify" }}>
                    We are enclosing herewith certified statement of shipping bills and bank realisation certificates (BRCs) against our said E-scrip on all applicable cases. We do hereby transfer the E-scrip in your favour as per current Foreign Trade Policy in force and applicable notifications as stated above. We also confirm that you will not require any separate authority from us and we shall have no right or claim of whatsoever on the said E-scrip henceforth.
                </p>

                <p className="mb-3" style={{ textAlign: "justify" }}>
                    We also confirm that the export proceeds/payments against all the shipping bills/export invoices covered under this E-scrip are realised or would be realised in due course as per RBI guidelines. We undertake that in case of any demand being raised by any authority for short or non realization of the proceeds we would be fully liable for the same. We indemnify the transferee and the actual user-importer against any such liabilities and actions under the above stated notifications.
                </p>

                <p className="mb-3" style={{ textAlign: "justify" }}>
                    We are fully responsible for the genuineness and bona fide of the said E-scrip. We hereby confirm to pay the amount to the transferee and the actual user-importer if demanded by any government authority due to any deficiency/fault of whatsoever nature raised against the said E-scrip.
                </p>

                <p className="mb-3" style={{ textAlign: "justify" }}>
                    We are transferring the E-scrip on ICEGATE portal in your E Ledger to <strong>{prefaceInfo.icegate_id}</strong> to complete the transfer to you. It is hereby agreed that the actual user-importer will operate on the said E-scrip and the goods thus imported will be strictly in accordance with the foreign trade policy in force for their sole benefit and for any infringement/violation of rule and regulation committed by them, they shall be fully responsible for the same and they shall keep us indemnified at all times.
                </p>
                <p className="mb-3" style={{ textAlign: "justify" }}>
                    The final responsibility for the accuracy, completeness, and timely submission of the BRC and related FEMA regulations shall rest solely with the exporter.
                </p>
            </div>

            {/* Signature Section */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "40px",
                    alignItems: "flex-start"
                }}
            >
                {/* Left Side - Sender Signature */}
                <div>
                    <p className="mb-1">Yours faithfully</p>
                    <p className="mb-0">For</p>
                    <div style={{ height: "60px" }}></div>
                    <p className="mb-1" style={{ fontWeight: "600" }}>
                        {data.client_name || "-"}
                    </p>
                    <p className="mb-1">Authorized Signatory.</p>
                    <p className="mb-0">Date: {formatDMY(data.date)}</p>
                </div>

                {/* Right Side - Bank Attestation Box */}
                <div
                    style={{
                        width: "200px",
                        minHeight: "100px",
                        border: "2px solid #000",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        padding: "5px",
                        fontWeight: "500",
                        fontSize: "12px",
                    }}
                >
                    Signature Attestation by Bank
                </div>
            </div>
        </Card>
    );
};

export default InwardLetter;